import type { Load } from '@sveltejs/kit';
import { error } from '@sveltejs/kit';

import { initStoryblok } from '../../../storyblok';

import { getLocaleFromUrl } from '../../../utils/locale.shared';
import { getBlogCategories, getBlogPost, getBlogPosts } from '../../../clients/storyblok.client';

export const load: Load = async ({ params, url, fetch, setHeaders }) => {
  setHeaders({ 'Cache-Control': 'max-age=0, s-maxage=86400' });

  const { language } = getLocaleFromUrl(url);
  const slug = params.slug;

  console.log('language', language);

  if (!slug) {
    error(400, 'Required parameter "slug" is missing');
  }

  try {
    // First, try to fetch the blog post
    console.log('Fetching blog post', slug);

    const post = await getBlogPost(fetch, { locale: language, slug });
    if (post) {
      return {
        isPost: true,
        post,
        locale: language
      };
    }

    // If blog post not found, try to fetch the category
    const { blogCategory } = await getBlogCategories(fetch, { locale: language, slug });
    if (blogCategory) {
      console.log('category', blogCategory);

      const page = Number(url.searchParams.get('page')) || 1;
      const perPage = 24;

      console.log('Fetching posts for category', blogCategory.defaultSlug);
      const { posts, pagination } = await getBlogPosts(fetch, { locale: language, page, perPage, category: blogCategory.defaultSlug });

      console.log('posts', posts);

      return {
        isCategory: true,
        category: blogCategory,
        posts: posts,
        pagination: pagination,
        locale: language
      };
    }

    // If neither blog post nor category found, throw a 404 error
    error(404, 'Blog post or category not found');
  } catch (e) {
    console.error(e);
    error(500, 'An error occurred while fetching data');
  }
};
